import { SharedFormationPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const SharedFormationPersistenceProvider = createStaticContextProvider(
  SharedFormationPersistenceContext,
  lazyValue(() =>
    import("./shared-formation-persistence").then(
      (module) => module.sharedFormationPersistence,
    ),
  ),
);
